import React from 'react';
import ReactDOM from 'react-dom';
import axios from 'axios';

import Calendar from '/components/estate-calendar/components/Calendar';

(async () => {
    const estateCalendarButton = document.querySelector('[data-estate-calendar-button]');

    if (estateCalendarButton) {
        const { data } = await axios.get(`${window.siteUrl}/index.php?p=actions/immodule/form/appointments&estateId=${window.estateId}`);

        if (data) {
            const { calendars: appointments } = data;

            ReactDOM.render(
                <Calendar appointments={ appointments } />,
                estateCalendarButton
            );
        }
    }
})();
